import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { withStyles, Paper } from "@material-ui/core";
import moment from "moment-timezone";
import { useIntl, FormattedMessage } from "react-intl";

import AudioIcon from "@material-ui/icons/Audiotrack";
import CameraIcon from "@material-ui/icons/CameraAlt";
import VideoIcon from "@material-ui/icons/Videocam";
import FileIcon from "@material-ui/icons/InsertDriveFile";
import PersonIcon from "@material-ui/icons/Person";

import { Tipografia, Flex } from "../../../../_common";
import TextDecoration from "../../../whatsapp/Shared/TextDecoration";

import { ORIGEM_MSG, MESSAGETYPES } from "../../../whatsapp/constants";
import { getChatIdentifier, showHistory, showHistoryPublicLink } from "../../../whatsapp/services";

const styles = {
  container: { display: "flex", flexDirection: "column", height: "100%", width: "100%", padding: "8px 8px 0px 8px" },
  titulo: { whiteSpace: "pre-line", paddingBottom: 5 },
  numero: { color: "#4B7AB7" },
  mensagens: { marginTop: 6 },
  boxMensagem: { margin: "0 0 0 5px" },
  remetente: { whiteSpace: "nowrap", color: "#666" },
  conversa: { fontSize: 12, marginBottom: 10 },
  icon: { fontSize: 14, margin: "0 4px", color: "#757587" },
  divLinkVisualizarHistorico: { marginTop: "auto", padding: "4px 0" },
  linkVisualizarHistorico: { color: "#457AB7 !important", cursor: "pointer" },
};

function TimeLineItemWhastApp({ classes, evento, isLinkPublico, isTimelineAtividades }) {
  const intl = useIntl();
  const showHistoryMessages = useCallback(
    () => {
      if (isLinkPublico) showHistoryPublicLink(evento);
      else showHistory(evento);
    },
    [evento, isLinkPublico]
  );

  const renderMessage = useCallback(message => {
    switch (message.tipo) {
      case MESSAGETYPES.IMAGE:
        return (
          <>
            <CameraIcon className={classes.icon} /> {`Imagem.${message.mensagem.split(".").pop()}`}
          </>
        );
      case MESSAGETYPES.AUDIO:
        return (
          <>
            <AudioIcon className={classes.icon} /> {`Áudio.${message.mensagem.split(".").pop()}`}
          </>
        );
      case MESSAGETYPES.VIDEO:
        return (
          <>
            <VideoIcon className={classes.icon} /> {`Video.${message.mensagem.split(".").pop()}`}
          </>
        );
      case MESSAGETYPES.APLICATION:
      case MESSAGETYPES.DOCUMENT:
        return (
          <>
            <FileIcon className={classes.icon} /> {`Arquivo.${message.mensagem.split(".").pop()}`}
          </>
        );
      case MESSAGETYPES.CONTACT:
        return (
          <>
            <PersonIcon className={classes.icon} /> Contato.vcf
          </>
        );
      case MESSAGETYPES.MEDIA:
        return intl.formatMessage({ defaultMessage: "Mídia em download..." });
      case MESSAGETYPES.TEXT:
        return <TextDecoration message={message.mensagem} />;

      default:
        return null;
    }
  }, []);

  return (
    <Paper className={classes.container} zDepth={1} id="divTimeLine" elevation={isTimelineAtividades ? 0 : 1}>
      <Flex alignItems="center">
        <Tipografia tipo="notaLegendas" cor="darkSecondaryText" className={classes.titulo}>
          <FormattedMessage defaultMessage="Conversa com" />
          <span className={classes.numero}>&nbsp;{getChatIdentifier({ telefoneLead: evento.telefoneLead })}&nbsp;</span>
          <FormattedMessage defaultMessage="via Integração WhatsApp." />
        </Tipografia>
      </Flex>

      <Tipografia tipo="notaLegendas" cor="darkSecondaryText">
        <div className={classes.mensagens}>
          {evento.mensagens?.map(mensagem => (
            <Flex key={mensagem.id} flexDirection="row" alignItems="flex-start" className={classes.conversa}>
              <p className={classes.boxMensagem}>
                <span className={classes.remetente}>
                  {`${
                    mensagem.origem === ORIGEM_MSG.SPOTTER
                      ? intl.formatMessage({ defaultMessage: "Você" })
                      : mensagem.nomeLead
                  } (${moment(mensagem.dateTimezone, "DD/MM/YYYY HH:mm:ss").format("HH:mm")}):`}&nbsp;&nbsp;
                </span>
                {renderMessage(mensagem)}
              </p>
            </Flex>
          ))}
        </div>
      </Tipografia>

      {!isTimelineAtividades && (
        <Flex justifyContent="flex-end" className={classes.divLinkVisualizarHistorico}>
          <Tipografia tipo="notaLegendas" onClick={showHistoryMessages} className={classes.linkVisualizarHistorico}>
            <FormattedMessage defaultMessage="Ver histórico completo" />
          </Tipografia>
        </Flex>
      )}
    </Paper>
  );
}

TimeLineItemWhastApp.propTypes = {
  classes: PropTypes.object,
  evento: PropTypes.object,
  isLinkPublico: PropTypes.bool,
  isTimelineAtividades: PropTypes.bool,
};

export default withStyles(styles)(TimeLineItemWhastApp);
